//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SchoolInvoiceNumberSettingsDisplayItem extends ItemBase {
    Enabled: boolean = false;
    NumberFormat: string | null = null;
    NextNumber: number = 0;

    constructor(initializer?: Partial<SchoolInvoiceNumberSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolInvoiceNumberSettingsDisplayItem";
}
